import React from 'react';
import useCampaigns from '../../Api/useCampaigns';

const CampaignsPage = () => {

  const uc = useCampaigns();
  const [campaigns, setCampaigns] = React.useState([]);
  const token = localStorage.getItem('token');

  React.useEffect(() => {
    async function getCampaigns() {
      const campaigns = await uc.getCampaigns(token);
      console.log(campaigns);
      setCampaigns(campaigns);
    }
    getCampaigns();
  }, []);

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-700 my-6">Campaigns</h1>
      <div className="flex flex-wrap">
         { campaigns.map((campaign) => (
            <div className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
              <div className="bg-white rounded-lg shadow-lg">
                <div className="p-4">
                  <h5 className="text-gray-900 font-bold text-xl tracking-tight mb-2">{campaign.name}</h5>
                  <p className="text-gray-700 text-base">{campaign.advertiser}</p>
                </div>
                <div className="flex items-center justify-between px-4 py-3 bg-gray-100 rounded-b-lg">
                  <a href={`/campaigns/${campaign.platform}/${campaign.campaign_id}`} className="text-blue-600 font-bold hover:underline">View Campaign</a>
                  <span className="text-gray-600 text-sm">{campaign.platform}</span>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default CampaignsPage;